import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  language: "en" | "fr";

  constructor(
    public translateService: TranslateService,
    private location: Location,
  ) {}

  initLanguage(){
    this.translateService.addLangs(["en", "fr"])
    let language = navigator.language || (navigator as any).userLanguage;
    language = language.split("-").includes("fr") ? "fr" : "en"
    this.translateService.setDefaultLang(language)

    // Change the URL without navigate:
    this.location.go(language)

    this.language=language as "en" | "fr"
  }

  changeLanguage(language: "en" | "fr"){
    this.translateService.setDefaultLang(language)
    this.location.go(language)
    this.language=language
  }
}
